import logoSrc from '../../assets/logo_atlas.png';
import b1 from '../../assets/gallery/b1.jpg';
import b2 from '../../assets/gallery/b2.jpg';
import b3 from '../../assets/gallery/b3.jpg';
import b4 from '../../assets/gallery/b4.jpg';
import b5 from '../../assets/gallery/b5.jpg';
import b6 from '../../assets/gallery/b6.jpg';
import b7 from '../../assets/gallery/b7.jpg';
import b8 from '../../assets/gallery/b8.jpg';
import b9 from '../../assets/gallery/b9.jpg';
import b1s from '../../assets/gallery/b1s.jpg';
import b2s from '../../assets/gallery/b2s.jpg';
import b3s from '../../assets/gallery/b3s.jpg';
import b4s from '../../assets/gallery/b4s.jpg';
import b5s from '../../assets/gallery/b5s.jpg';
import b6s from '../../assets/gallery/b6s.jpg';
import b7s from '../../assets/gallery/b7s.jpg';
import b8s from '../../assets/gallery/b8s.jpg';
import b9s from '../../assets/gallery/b9s.jpg';
import {styled, useMediaQuery} from "@mui/material";
import {Stack} from "@mui/material";
import {useCachedImage} from "../../styling/useCachedImage";
import MobileMenu from "./MobileMenu";
import DesktopMenu from "./DesktopMenu";
import Carousel from "./Carousel";
import LanguageDropdown from "../../translations/LanguageDropdown";


const Header = () => {
    const isMobile = useMediaQuery('(max-width:800px)');

    const largeImages = [b8, b4, b1, b6, b3, b7, b5, b2, b9];
    const smallImages = [b8s, b4s, b1s, b6s, b3s, b7s, b5s, b2s, b9s];
    const galleryImages = isMobile ? smallImages : largeImages;

    const Logo = styled('img')({
        maxHeight: '100px',
        width: 'auto',
        height: 'auto',
        minWidth: 0,
        flexShrink: 1,
        padding: '20px',
        objectFit: 'contain',
        maxWidth: '100%'
    });


    const logo = useCachedImage('logo', logoSrc);


    return (
        <Stack direction="column">
            {/*line with logo and menus*/}
            <Stack direction="row">
                <Logo src={logo ?? logoSrc} alt="logo"/>
                <Stack direction={isMobile ? "row-reverse" : "row"}
                       justifyContent={isMobile ? "end" : "space-between"}
                       gap="20px"
                       width="100%"
                       alignItems="bottom"
                       padding="20px"
                >
                    {isMobile ? <MobileMenu/> : <DesktopMenu/>}
                    <LanguageDropdown/>
                </Stack>

            </Stack>
            {/*carousel*/}
            <Carousel images={galleryImages}/>
        </Stack>
    )
}

export default Header;